import { Box } from "@chakra-ui/react";
import { useSelector } from "react-redux";
import AgentServicesSessionTime from "../../components/branches/reports/AgentServicesSessionTime";
import { getReportDescription } from "../../store/helpers";
import _ from "lodash";
import * as defaultSelectors from "../../store/selectors/defaultSelector";
import { getRenderConfigSummaryItems } from "../../store/renderConfig";

export const getAgentServiceTimeDescription = (reportRange, renderConfig) => {
  const startLabel = reportRange === "month" ? "Monthly" : reportRange === "week" ? "Weekly" : "Daily";
  if (renderConfig?.charts?.enabled === false) {
    return `${startLabel} overview of the total service time each agent took to complete each service per branch. This table view includes total service time, percentage share, average, minimum, and maximum service time.`;
  }
  return getReportDescription(reportRange).AgentServiceSessionTime;
};

const AgentServiceTimePerService = ({
  
  reportIndex = "**REPORT_INDEX**",
}) => {
  const reportRange = useSelector(defaultSelectors.selectReportRange);
  const reportsData = useSelector(defaultSelectors.selectReportsData);
  const renderConfig = useSelector(defaultSelectors.selectRenderConfig);
  let { data } = reportsData;

  const title = `${reportIndex}. Agent Service Time Per Service`;
  const description = getAgentServiceTimeDescription(reportRange, renderConfig);
  const presentationSummaryItems = getRenderConfigSummaryItems(renderConfig);

  //requires array of objects
  if (!_.isArray(data)) {
    data = [data];
  }  

  return (
    <Box>
      <h1>{title}</h1>{" "}
        <p>{description}</p>
        {presentationSummaryItems.length ? (
          <div className="reportPresentationSummary">
            <span className="reportPresentationSummaryLabel">Presentation</span>
            <span className="reportPresentationSummaryValue">
              {presentationSummaryItems.join(" / ")}
            </span>
          </div>
        ) : null}
        {Array.isArray(data) && data.length > 0 ? (
          <>
            <AgentServicesSessionTime reportIndex={reportIndex} data={data} />
          </>
        ) : (
          <Box mt={10}>
            <p>No data available in this search</p>
          </Box>
        )}
    </Box>
  );
};

export default AgentServiceTimePerService;
